import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ItemDetailsDialog = ({ open, onClose, param }) => {
  if (!param || param.length === 0) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ textAlign: 'center', position: 'relative' }}>
        Item Details
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ maxHeight: '60vh' }}>
        {param.items?.map((item, index) => (
          <Box
            key={index}
            sx={{
              border: '1px solid #ddd',
              borderRadius: 2,
              padding: 2,
              marginBottom: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
            }}
          >
            <Box display="flex" justifyContent="space-between" mb={1}>
              <Typography fontWeight="bold">Item Name:</Typography>
              <Typography>{item.item_name}</Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" mb={1}>
              <Typography fontWeight="bold">Quantity:</Typography>
              <Typography>{item.quantity}</Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" mb={1}>
              <Typography fontWeight="bold">Rate:</Typography>
              <Typography>₹{item.rate}</Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" mb={1}>
              <Typography fontWeight="bold">Tax (%):</Typography>
              <Typography>{item.tax}%</Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" mb={1}>
              <Typography fontWeight="bold">Tax Amount:</Typography>
              <Typography>₹{item.tax_amount}</Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" mb={1}>
              <Typography fontWeight="bold">Taxable Value:</Typography>
              <Typography>₹{item.taxable_value}</Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography fontWeight="bold">Total Amount:</Typography>
              <Typography>₹{item.total_amount}</Typography>
            </Box>
          </Box>
        ))}
      </DialogContent>
    </Dialog>
  );
};

export default ItemDetailsDialog;
